export enum Actions {
  POP = 'POP',
  REPLACE = 'REPLACE',
  PUSH = 'PUSH'
}
